export default __webpack_public_path__ + "static/media/hills-complete.32ea4cf0.svg";